<ngb-toast
  *ngFor="let toast of toastService.toasts; trackBy: trackByToastId"
  [class]="'toast-' + toast.type"
  [delay]="toast.delay"
  [autohide]="toast.delay !== 0"
  (hidden)="onClose(toast.id)"
>
  <ng-template ngbToastHeader>
    <i [class]="toastService.getIconClass(toast.type)" class="me-2"></i>
    <strong class="me-auto">{{ toast.title }}</strong>
  </ng-template>

  <div class="toast-body">
    <p class="mb-2">{{ toast.message }}</p>
    
    <div *ngIf="toast.actions && toast.actions.length > 0" class="d-flex gap-2 mt-3">
      <button 
        *ngFor="let action of toast.actions" 
        type="button" 
        class="btn btn-sm"
        [class]="toastService.getButtonClass(action.style)"
        (click)="onActionClick(action, toast.id)"
      >
        {{ action.label }}
      </button>
    </div>
  </div>
</ngb-toast>
